export const locationHasCoordinates = location => {
  if (!location) {
    return false
  }
  const { lat, lng } = location
  if (lat === null || lat === undefined || lat === '') {
    return false
  }
  if (lng === null || lng === undefined || lng === '') {
    return false
  }
  return Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))
}

export const locationDisplayName = location =>
  location?.displayName ||
  location?.name ||
  location?.practice?.name ||
  ''

/**
 * Provider offices that appear in the active search result set (bbox hits + chips).
 */
export const matchedProviderLocations = (provider, store) => {
  if (!provider?.id) {
    return []
  }
  return store.locationStore.activeSearchResultLocations.filter(
    location =>
      locationHasCoordinates(location) &&
      (location.providers || []).some(
        currentProvider => currentProvider?.id === provider.id
      )
  )
}

const sortProviderLocationDetails = (rows, matchedIds) =>
  [...rows].sort((a, b) => {
    const aInSearch = matchedIds.has(a.location?.id)
    const bInSearch = matchedIds.has(b.location?.id)
    if (aInSearch !== bInSearch) {
      return aInSearch ? -1 : 1
    }
    return locationDisplayName(a.location).localeCompare(
      locationDisplayName(b.location),
      undefined,
      { sensitivity: 'base' }
    )
  })

/**
 * Full provider footprint for the detail panel (in-search rows enriched from store).
 */
const resolveAffiliationRows = (provider, store) => {
  const fromProviderLocations = (provider.providerLocations ?? []).filter(
    details => details.location?.id
  )
  if (fromProviderLocations.length > 0) {
    return fromProviderLocations
  }

  if (provider.locations?.length) {
    return provider.locations
      .map((location, index) => {
        const resolved =
          typeof location === 'string'
            ? store.locations.get(location)
            : location
        if (!resolved?.id) {
          return null
        }
        return {
          id: `legacy-affiliation-${resolved.id}`,
          location: resolved,
        }
      })
      .filter(Boolean)
  }

  return matchedProviderLocations(provider, store).map(location => ({
    id: `matched-${location.id}`,
    location,
  }))
}

export const allProviderLocationDetails = (provider, store) => {
  const matchedIds = new Set(store.searchStore.searchResultLocationIds)
  const matchedById = new Map(
    matchedProviderLocations(provider, store).map(location => [
      location.id,
      location,
    ])
  )

  const rows = resolveAffiliationRows(provider, store).map(details => {
    const locationId = details.location.id
    const enrichedLocation = matchedById.get(locationId) ?? details.location
    return {
      ...details,
      location: enrichedLocation,
    }
  })

  return sortProviderLocationDetails(rows, matchedIds)
}

export const locationNeedsHydration = location =>
  Boolean(
    location?.id &&
      (!location.street ||
        !locationHasCoordinates(location))
  )
